export const defaultData = {
  Campaigns: [
    { translationKey: _TL_('How do I create a campaign?'), category: 'support' },
    { translationKey: _TL_('What bid strategies can I use?'), category: 'support' },
    { translationKey: _TL_('What are the ad types I can create?'), category: 'support' },
    { translationKey: _TL_('How do I control which websites my ads appear on?'), category: 'support' },
    { translationKey: _TL_('How can I control where my ad shows?'), category: 'support' },
    { translationKey: _TL_('How does my Budget work?'), category: 'support' },
    { translationKey: _TL_('How do Keywords work?'), category: 'support' },
    { translationKey: _TL_('What are Keyword Match Types?'), category: 'support' },
    { translationKey: _TL_('How does location targeting work?'), category: 'support' },
    { translationKey: _TL_('How do I create Audience targeting?'), category: 'support' },
  ],
  AdDelivery: [
    { translationKey: _TL_('How do I control which websites my ads appear on?'), category: 'support' },
    { translationKey: _TL_('How do I know if my clicks are genuine?'), category: 'support' },
    { translationKey: _TL_('Are my ads live?'), category: 'support' },
    { translationKey: _TL_('My ads are live - why can\'t I find them?'), category: 'support' },
    { translationKey: _TL_('How can I control where my ad shows?'), category: 'support' },
    { translationKey: _TL_('Why is my account in budget pause?'), category: 'support' },
    { translationKey: _TL_('Why do I see extensions I didn\'t create showing on my ads?'), category: 'support' },
    { translationKey: _TL_('What do the various delivery status\' mean?'), category: 'support' },
    { translationKey: _TL_('What bid strategies can I use to improve my competitiveness?'), category: 'support' },
    { translationKey: _TL_('How can I find keywords to help my ads reach more people?'), category: 'support' },
  ],
  Import: [
    { translationKey: _TL_('How to I manage scheduled Imports for my campaigns?'), category: 'support' },
    { translationKey: _TL_('How do I manage what campaign information gets imported from Google?'), category: 'support' },
    { translationKey: _TL_('How do I import campaigns from Google?'), category: 'support' },
    { translationKey: _TL_('How do I import campaigns from Facebook?'), category: 'support' },
    { translationKey: _TL_('How do I import campaigns from an offline file?'), category: 'support' },
    { translationKey: _TL_('How do I make bulk changes to campaigns in my account?'), category: 'support' },
  ],
  MerchantCenter: [
    { translationKey: _TL_('How do I set up a Microsoft Merchant Center Store'), category: 'support' },
    { translationKey: _TL_('How do I claim my domain'), category: 'support' },
    { translationKey: _TL_('How do I set up a Microsoft Shopping campaign'), category: 'support' },
    { translationKey: _TL_('How do I set up a Microsoft Shopping Feed'), category: 'support' },
    { translationKey: _TL_('How do I download a Feed File'), category: 'support' },
    { translationKey: _TL_('I can\'t match the file to a feed'), category: 'support' },
    { translationKey: _TL_('My Catalog/Feed Items are Rejected/Disapproved'), category: 'support' },
    { translationKey: _TL_('How do I update my offers through a manual feed, FTP/SFTP, or via API'), category: 'support' },
    { translationKey: _TL_('How do I set up UET using Shopify'), category: 'support' },
    { translationKey: _TL_('Whats the Minimum bid for Microsoft shopping campaigns'), category: 'support' },
    { translationKey: _TL_('What are Local Inventory Ads?'), category: 'support' },
    { translationKey: _TL_('What is Microsoft Merchant Center?'), category: 'support' },
    { translationKey: _TL_('What are Product ads?'), category: 'support' },
    { translationKey: _TL_('Why is my offer non compliant'), category: 'support' },
    { translationKey: _TL_('Understand and use Product Groups'), category: 'support' },
    { translationKey: _TL_('Get started with shopping campaigns'), category: 'support' },
    { translationKey: _TL_('Product ads filter limits'), category: 'support' },
    { translationKey: _TL_('Learn about product filters for Microsoft Shopping campaigns'), category: 'support' },
    { translationKey: _TL_('About smart shopping campaigns'), category: 'support' },
    { translationKey: _TL_('Product ads (All the help article associated in Shopping is linked in this page)'), category: 'support' },
  ],
  AssetManagement: [
    { translationKey: _TL_('Where do I manage my images, videos, etc?'), category: 'support' },
    { translationKey: _TL_('Why are my images getting cropped?'), category: 'support' },
    { translationKey: _TL_('What are the image guidelines I need to follow?'), category: 'support' },
    { translationKey: _TL_('What are the video guidelines I need to follow?'), category: 'support' },
    { translationKey: _TL_('What kinds of video ad can I create?'), category: 'support' },
    { translationKey: _TL_('What are image extensions?'), category: 'support' },
    { translationKey: _TL_('What are video extensions?'), category: 'support' },
  ],
  Reports: [
    { translationKey: _TL_('What are the best reports to track and improve performance?'), category: 'support' },
    { translationKey: _TL_('How can I see what changes were made in my account?'), category: 'support' },
    { translationKey: _TL_('How can I see what keywords triggered my ad?'), category: 'support' },
    { translationKey: _TL_('How can I see how competitive my campaigns are?'), category: 'support' },
    { translationKey: _TL_('How do I create a report?'), category: 'support' },
    { translationKey: _TL_('What do the report statistics mean?'), category: 'support' },
    { translationKey: _TL_('How do I create custom columns?'), category: 'support' },
    { translationKey: _TL_('What do the different column types mean?'), category: 'support' },
  ],
  Conversions: [
    { translationKey: _TL_('How do I set up conversion tracking?'), category: 'support' },
    { translationKey: _TL_('How do I ensure my conversion tracking is set up properly?'), category: 'support' },
    { translationKey: _TL_('How do I set up custom event tracking?'), category: 'support' },
    { translationKey: _TL_('How do I set up UET via Google Tag Manager?'), category: 'support' },
    { translationKey: _TL_('How do I set up variable revenue tracking?'), category: 'support' },
    { translationKey: _TL_('Why am I seeing a discrepancy between Microsoft Advertising conversion data and 3rd party data?'), category: 'support' },
    { translationKey: _TL_('How do I set up offline conversion tracking?'), category: 'support' },
    { translationKey: _TL_('Can I use one UET tag for all of my conversion goals or accounts?'), category: 'support' },
    { translationKey: _TL_('How do I set up UET using a 3rd party website platform?'), category: 'support' },
  ],
  Billing: [
    { translationKey: _TL_('How do I add a payment method?'), category: 'support' },
    { translationKey: _TL_('What are the payment options in my country?'), category: 'support' },
    { translationKey: _TL_('When will my payment be processed on my account?'), category: 'support' },
    { translationKey: _TL_('What is an account hold and what should I do?'), category: 'support' },
    { translationKey: _TL_('How do I fix a declined payment?'), category: 'support' },
    { translationKey: _TL_('How do I pay with a credit card?'), category: 'support' },
    { translationKey: _TL_('When will I receive my refund to my payment method?'), category: 'support' },
    { translationKey: _TL_('Why do you need my business location?'), category: 'support' },
    { translationKey: _TL_('Where can I update my business address?'), category: 'support' },
    { translationKey: _TL_('Why is my account on hold?'), category: 'support' },
  ],
  Troubleshooting: [
    { translationKey: _TL_('Diagnose and review campaign delivery blockers.'), category: 'troubleshooting' },
  ],
  default: [
    { translationKey: _TL_('How do I create a campaign?'), category: 'support' },
    { translationKey: _TL_('What bid strategies can I use?'), category: 'support' },
    { translationKey: _TL_('What are the ad types I can create?'), category: 'support' },
  ],
};
